var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view form-view",attrs:{"id":"organization-create-view"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('createOrganization.title')))]),_c('organization-form',{attrs:{"form":_vm.form,"handler":_vm.createOrganization}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }